import { vehicles } from '../../../mocks/vehicles';

export default function FleetSection() {
  const scrollToQuote = () => {
    const element = document.getElementById('orcamento');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="frota" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#1e3a8a]/10 rounded-full">
            <span className="text-[#1e3a8a] font-semibold text-sm flex items-center gap-2">
              <i className="ri-star-fill"></i>
              Nossa Frota Premium
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a8a] mb-4">
            Veículos Modernos e<br />Confortáveis para Sua Família
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {vehicles.slice(0, 3).map((vehicle) => (
            <div
              key={vehicle.id}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2"
              data-product-shop
            >
              <div className="relative h-64 w-full">
                <img
                  src={vehicle.image}
                  alt={`${vehicle.name} ${vehicle.year}`}
                  className="w-full h-full object-cover object-center"
                />
                <div className={`absolute top-4 right-4 ${vehicle.badgeColor} text-white px-4 py-2 rounded-full font-bold text-sm`}>
                  {vehicle.badge}
                </div>
              </div>

              <div className="p-6 bg-white">
                <h3 className="text-2xl font-bold text-[#1e3a8a] mb-3">
                  {vehicle.name} {vehicle.year}
                </h3>

                <div className="flex items-center gap-4 mb-4 text-sm text-gray-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {vehicle.passengers} passageiros
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-gas-station-line"></i>
                    {vehicle.fuel}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-settings-3-line"></i>
                    {vehicle.transmission}
                  </span>
                </div>

                <p className="text-gray-600 mb-4 text-sm">
                  {vehicle.description}
                </p>

                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-3xl font-bold text-[#c53030]">
                      ${vehicle.pricePerDay}
                    </span>
                    <span className="text-gray-600">/dia</span>
                  </div>
                  <button
                    onClick={scrollToQuote}
                    className="px-6 py-3 border-2 border-[#1e3a8a] text-[#1e3a8a] rounded-lg font-semibold hover:bg-[#1e3a8a] hover:text-white transition-all whitespace-nowrap cursor-pointer"
                  >
                    Ver Detalhes
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div
            className="md:col-span-2 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all"
            data-product-shop
          >
            <div className="flex flex-col md:flex-row h-full">
              <div className="md:w-1/2 h-64 md:h-auto">
                <img
                  src={vehicles[3].image}
                  alt={`${vehicles[3].name} ${vehicles[3].year}`}
                  className="w-full h-full object-cover object-center"
                />
              </div>

              <div className="md:w-1/2 p-8 flex flex-col justify-center">
                <div className={`inline-block mb-4 ${vehicles[3].badgeColor} text-white px-4 py-2 rounded-full font-bold text-sm w-fit`}>
                  {vehicles[3].badge}
                </div>

                <h3 className="text-3xl font-bold text-white mb-3">
                  {vehicles[3].name} {vehicles[3].year}
                </h3>

                <div className="flex items-center gap-4 mb-4 text-sm text-white/80">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {vehicles[3].passengers} passageiros
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-car-line"></i>
                    {vehicles[3].type}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-settings-3-line"></i>
                    {vehicles[3].transmission}
                  </span>
                </div>

                <p className="text-white/80 mb-6">
                  {vehicles[3].description}
                </p>

                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-4xl font-bold text-[#c53030]">
                      ${vehicles[3].pricePerDay}
                    </span>
                    <span className="text-white/80">/dia</span>
                  </div>
                  <button
                    onClick={scrollToQuote}
                    className="px-6 py-3 bg-[#c53030] text-white rounded-lg font-semibold hover:bg-[#a02525] transition-all whitespace-nowrap cursor-pointer"
                  >
                    Escolher Este Veículo
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#1e3a8a] to-[#1e3a8a]/80 rounded-2xl p-8 flex flex-col justify-center text-white">
            <i className="ri-shield-check-line text-6xl text-[#c53030] mb-6"></i>
            <h3 className="text-2xl font-bold mb-4">
              Todos os Veículos Incluem
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <i className="ri-check-line text-[#c53030] text-xl"></i>
                <span>Seguro Completo</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-check-line text-[#c53030] text-xl"></i>
                <span>Ar Condicionado</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-check-line text-[#c53030] text-xl"></i>
                <span>Suporte 24/7</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-check-line text-[#c53030] text-xl"></i>
                <span>Sem Taxas Ocultas</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
